import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  SecondaryHeaderDataProps, SecondaryHeaderProps, SecondaryHeaderThemeProps,
} from '../../components/navigation/header/secondaryHeader/SecondaryHeader';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { secondaryHeaderHeight } from '../../components/navigation/header/header.utils';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { AMPLogo } from './AMPLogo';
import { AMPSecondaryLinks } from './AMPSecondaryLinks';

const componentConfigThemeKey = 'secondaryHeader';

const createStyle = (vrLineHeight: VrLineHeight, backgroundColor:string) => {
  return StyleSheet.create({
    wrapper: {
      backgroundColor,
      position: 'relative',
      height: `${secondaryHeaderHeight}px`,
      display: 'grid',
      gridAutoFlow: 'column',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 50,
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        gridColumnGap: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        gridColumnGap: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        gridColumnGap: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        gridColumnGap: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
      },
    },
  });
};

export const AMPSecondaryHeaderComponent: React.FunctionComponent<SecondaryHeaderProps> = props => {
  const { vrLineHeight, backgroundColor, surfaceStyle, moreLinksText, secondaryLinks, secondaryLogos, pagePath } = props;
  const style = createStyle(vrLineHeight, backgroundColor);
  return (
    <div className={css(style.wrapper, StyleSheet.create({ surfaceStyle }).surfaceStyle)}>
      { secondaryLogos ? <AMPLogo {...secondaryLogos} /> : null }
      { secondaryLinks ? <AMPSecondaryLinks links={secondaryLinks} moreLinksText={moreLinksText} pagePath={pagePath} /> : null }
    </div>
  );
};

const mapThemeProps = (theme: SecondaryHeaderThemeProps) => {
  return {
    vrLineHeight: theme.vrLineHeight,
    backgroundColor: theme.backgroundColor,
    surfaceStyle: theme.surfaceStyle,
  };
};

export const AMPSecondaryHeader = (props: SecondaryHeaderDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <ErrorBoundary><AMPSecondaryHeaderComponent {...themeContext} {...props} /></ErrorBoundary>;
};
